import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';
import { RegistrationRouteReuseStrategy } from './features/registration/application/registration-route-reuse.strategy';
import { ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: '+0900' } },
    { provide: RouteReuseStrategy, useClass: RegistrationRouteReuseStrategy },
    provideRouter(routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
      withRouterConfig({ canceledNavigationResolution: 'computed' })),
    provideHttpClient(),
    provideAnimations(),
    provideToastr(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json', failOnError: true }),
      fallbackLang: 'ja',
    }),
  ],
};
